/* SkinVibe: filmy klientek - kafelki i okno z filmem (11.10.2026, sesja 7ea9476e; analiza i pomiary:
   docs/research/wideo-karuzele-2026-10-11/). Element <sv-reels> (kafelki) + jedno wspólne okno (div na końcu <body>,
   warstwa popover = top layer nad całą stroną, więc żaden rodzic z transform, np. kolumna opisu karty po animacji wjazdu,
   go nie przycina). Nie <dialog>.showModal(): lab 11.10 (Android, CPU 4x) - okno modalne wyłącza resztę strony i przelicza
   style całej karty, otwarcie 256 ms (stare okno 96 ms); popover bez tego kosztu. Bez rozmyć (backdrop-filter, filter: blur).
   Zasady:
   - kafelek = zdjęcie; film pobiera się dopiero w oknie: telefon 720p, komputer 1080p tylko przy dużej ramce (inaczej 720p),
     oszczędzanie danych 480p; bez HLS na start (recenzja 11.10: najpierw test na prawdziwym iPhonie);
   - ruch w kafelkach tylko z krótkich zajawek (4 s, ok. 160 KB, assets/sv-reels-zajawki.json: klucz z adresu filmu -> plik):
     gdy karuzela wjedzie na ekran (i po każdym jej przewinięciu), raz gra pierwszy w pełni widoczny kafelek, bez dźwięku
     (WCAG 2.2.2: ruch krótszy niż 5 s); na komputerze zajawka w pętli po celowym najechaniu myszą; bez zajawki = samo zdjęcie;
     bez ruchu przy ograniczeniu ruchu i oszczędzaniu danych; ustawienie „Autoplay video” w sekcjach nie ma skutku (od 11.10);
   - w oknie pasek przewijania filmu na dole (przeciąganie palcem i myszą, klawiatura), jak YouTube Shorts (12.10);
   - w oknie jeden element <video> przenoszony między slajdami: dźwięk włączony gestem działa też po przewinięciu (iOS);
     play() wołane synchronicznie w obsłudze dotknięcia; gdy przeglądarka odmówi dźwięku, film gra wyciszony z przyciskiem „Włącz dźwięk”;
   - przy otwarciu pauza wszystkich innych filmów strony (koniec dwóch dźwięków naraz), po zamknięciu wznowienie tylko wyciszonych;
   - zamknięcie: X, Esc, klik w tło (komputer), „wstecz” w telefonie (historia), fokus wraca na kafelek;
   - zdarzenia: window.svTrack('sv_reel', {action: view|open|complete|cta|unmute|fallback}) + sv_video_play z sv-events.js
     (kontekst z data-sv-reels-context); view = karuzela w widoku (mianownik), raz na stronę. */
(() => {
  if (window.svReels) return;
  const DESK = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  const conn = navigator.connection || {};
  const KEY_MUTED = 'svReelsMuted';
  const KEY_HINT = 'svReelsHint';
  const SVG = (inner, fill) => `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="${fill ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${inner}</svg>`;
  /* ikony: x, play, chevron-up/down 1:1 z snippets/lm-svg-icons.liquid; głośnik i pauza z tej samej rodziny (Feather / iconsvg.xyz) */
  const ICON = {
    x: SVG('<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>'),
    play: SVG('<polygon points="5 3 19 12 5 21 5 3" fill="currentColor"></polygon>'),
    up: SVG('<path d="M18 15l-6-6-6 6"/>'),
    down: SVG('<path d="M6 9l6 6 6-6"/>'),
    volOn: '<span class="svr-ico-off">' + SVG('<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>') + '</span>',
    volOff: '<span class="svr-ico-on">' + SVG('<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>') + '</span>',
    mutedSmall: SVG('<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>')
  };
  let T = null;
  const txt = (k, o) => {
    if (!T) {
      const el = document.querySelector('script[data-sv-reels-i18n]');
      try { T = JSON.parse(el ? el.textContent : '{}'); } catch (e) { T = {}; }
      /* filtr t w Shopify zamienia ' na &#39; (it, nl): odkodowanie raz, potem teksty idą przez esc() albo textContent (przegląd 12.10, W1) */
      const ta = document.createElement('textarea');
      Object.keys(T).forEach((k) => { if (typeof T[k] === 'string' && T[k].indexOf('&') !== -1) { ta.innerHTML = T[k]; T[k] = ta.value; } });
    }
    let s = T[k] || '';
    if (o) Object.keys(o).forEach((p) => { s = s.split('[[' + p + ']]').join(o[p]); });
    return s;
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const store = {
    get: (k) => { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };
  const track = (name, data) => { try { if (window.svTrack) window.svTrack(name, data); } catch (e) {} };

  function srcFor(it) {
    if (conn.saveData) return it.m480 || it.m720 || it.m1080;
    /* 1080p (606 px szerokości) tylko gdy ramka filmu ma w pikselach ekranu > 420 px (komputer z dużą ramką albo Retina);
       telefon zawsze 720p (404 px): na ekranie ok. 400 px szerokości 1080p nic nie daje, a waży 33 zamiast 21 MB na 38 s */
    if (DESK.matches) {
      /* szerokość ramki z formuły CSS (.svr-stage na komputerze), bez odczytu układu w obsłudze dotknięcia (lab 12.10) */
      const fw = Math.min(window.innerHeight * 0.92, 940) * 9 / 16;
      if (fw * (window.devicePixelRatio || 1) > 420) return it.m1080 || it.m720 || it.m480;
    }
    return it.m720 || it.m1080 || it.m480;
  }
  function itemOf(btn) {
    const d = btn.dataset;
    return {
      m480: d.m480 || '', m720: d.m720 || '', m1080: d.m1080 || '',
      poster: d.poster || '', bg: d.posterSm || d.poster || '', label: d.label || '', pos: (+d.svReel || 0) + 1,
      product: d.productUrl ? { url: d.productUrl, title: d.productTitle || '', price: d.productPrice || '', img: d.productImg || '', handle: d.productHandle || '' } : null
    };
  }

  /* ---------- zajawki w kafelkach (bez dźwięku, 4 s, najwyżej jedna naraz na stronie) ---------- */
  let ZP = null; // obietnica mapy zajawek (pobierana raz, dopiero gdy karuzela jest na ekranie)
  let ZM = null; // mapa: klucz filmu (32 znaki z adresu .../vp/<klucz>/...) -> adres zajawki
  let autoplayBlocked = false; // np. tryb oszczędzania energii na iPhonie: bez ruchu do końca wizyty
  function zajawki() {
    if (!ZP) {
      const u = txt('teasers');
      ZP = (u ? fetch(u, { credentials: 'omit' }).then((r) => (r.ok ? r.json() : {})).catch(() => ({})) : Promise.resolve({}))
        .then((m) => { ZM = m && typeof m === 'object' ? m : {}; return ZM; });
    }
    return ZP;
  }
  function zajawkaOf(btn) {
    if (!ZM) return '';
    const m = /\/vp\/([0-9a-f]{32})\//.exec(btn.dataset.m1080 || btn.dataset.m720 || btn.dataset.m480 || '');
    return (m && ZM[m[1]]) || '';
  }
  let previewing = null;
  function previewStart(btn, once) {
    if (REDUCED.matches || conn.saveData || autoplayBlocked || (S && isOpen()) || btn.hasAttribute('data-no-preview')) return;
    const src = zajawkaOf(btn);
    if (!src) return;
    /* inny kafelek gra: zatrzymany (jeden ruch naraz; bez tego zbierało się kilka filmów w pamięci telefonu) */
    if (previewing && previewing !== btn) previewStop(previewing);
    let v = btn.querySelector('video');
    if (!v) {
      v = document.createElement('video');
      v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto';
      ['muted', 'playsinline', 'webkit-playsinline', 'disablepictureinpicture'].forEach((a) => v.setAttribute(a, ''));
      v.setAttribute('aria-hidden', 'true'); v.setAttribute('tabindex', '-1');
      v.addEventListener('playing', () => { if (previewing === btn) btn.classList.add('is-preview'); });
      v.addEventListener('ended', () => { if (previewing === btn) previewStop(btn, true); });
      v.addEventListener('error', () => { btn.setAttribute('data-no-preview', ''); if (previewing === btn) previewing = null; previewStop(btn); });
      v.src = src;
      btn.insertBefore(v, btn.querySelector('.sv-reels__shade'));
    }
    v.loop = !once;
    previewing = btn;
    if (!v.paused && v.readyState > 2) btn.classList.add('is-preview');
    const p = v.play();
    if (p && p.catch) p.catch((err) => {
      if (err && err.name === 'AbortError') return;
      if (err && err.name === 'NotAllowedError') autoplayBlocked = true; /* zepsuty plik zajawki nie wyłącza pozostałych */ /* zostaje samo zdjęcie (bez systemowej ikony odtwarzania na zatrzymanym filmie) */
      if (previewing === btn) previewing = null;
      previewStop(btn);
    });
  }
  function previewStop(btn, fade) {
    if (!btn) return;
    const v = btn.querySelector('video');
    btn.classList.remove('is-preview');
    if (previewing === btn) previewing = null;
    if (!v) return;
    /* koniec zajawki: wygaszenie do zdjęcia (0,35 s), potem usunięcie filmu i przerwanie pobierania */
    const kill = () => { if (previewing === btn) return; try { v.pause(); } catch (e) {} v.removeAttribute('src'); try { v.load(); } catch (e) {} v.remove(); };
    if (fade && !REDUCED.matches) setTimeout(kill, 400); else kill();
  }
  document.addEventListener('visibilitychange', () => { if (document.hidden && previewing) previewStop(previewing); });
  /* raz: pierwszy w pełni widoczny kafelek, który jeszcze nie grał (po wjechaniu karuzeli na ekran i po jej przewinięciu) */
  function autoNext(comp) {
    if (autoplayBlocked || REDUCED.matches || conn.saveData || (S && isOpen()) || !comp._svVisible || previewing) return;
    zajawki().then(() => {
      if (!comp._svVisible || previewing || (S && isOpen())) return;
      const tr = comp.track.getBoundingClientRect();
      const t = comp.tiles.find((b) => { const r = b.getBoundingClientRect(); return !b._svDone && r.left >= tr.left - 2 && r.right <= tr.right + 2 && r.width > 0; });
      if (!t || !zajawkaOf(t) || (comp._svAuto || 0) >= 4) return; /* najwyżej 4 automatyczne zajawki na karuzelę (ok. 0,6 MB) */
      t._svDone = true;
      comp._svAuto = (comp._svAuto || 0) + 1;
      previewStart(t, true);
    });
  }
  const autoIo = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const comp = e.target;
      comp._svVisible = e.isIntersecting && e.intersectionRatio >= 0.5;
      if (comp._svVisible) autoNext(comp);
      else if (previewing && comp.contains(previewing)) previewStop(previewing, true);
    });
  }, { threshold: [0, 0.5] }) : null;
  /* karuzela w widoku: raz na stronę na element, mianownik do odsetka otwarć (recenzja 11.10) */
  const seenIo = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      seenIo.unobserve(e.target);
      track('sv_reel', { action: 'view', context: e.target.dataset.context || 'other', position: 0, video: '', product: e.target.dataset.pdpHandle || '' });
    });
  }, { threshold: 0.5 }) : null;

  /* ---------- kafelki ---------- */
  class SvReels extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('.sv-reels__track');
      this.tiles = Array.prototype.slice.call(this.querySelectorAll('.sv-reels__tile'));
      this.prevBtn = this.querySelector('.sv-reels__nav--prev');
      this.nextBtn = this.querySelector('.sv-reels__nav--next');
      if (!this.track || !this.tiles.length) return;
      this.tiles.forEach((b, i) => {
        b.addEventListener('click', () => openPlayer(this, i, b));
        b.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || !DESK.matches) return;
          clearTimeout(b._svt);
          /* celowe najechanie, nie przelot kursora; zajawka w pętli */
          b._svt = setTimeout(() => zajawki().then(() => { if (b.matches(':hover')) previewStart(b, false); }), 350);
        });
        b.addEventListener('pointerleave', (e) => { clearTimeout(b._svt); if (e.pointerType === 'mouse' && previewing === b) previewStop(b, true); });
      });
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._sva);
        this._sva = setTimeout(() => {
          /* grający kafelek wyjechał z widoku: stop; potem zajawka pierwszego widocznego, który jeszcze nie grał */
          if (previewing && this.contains(previewing)) {
            const tr = this.track.getBoundingClientRect(); const r = previewing.getBoundingClientRect();
            if (r.right < tr.left + 8 || r.left > tr.right - 8) previewStop(previewing, true);
          }
          autoNext(this);
        }, 300);
      }, { passive: true });
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this.page(-1));
        this.nextBtn.addEventListener('click', () => this.page(1));
        this.track.addEventListener('scroll', () => {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => { this._raf = 0; this.nav(); });
        }, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(() => this.nav()).observe(this.track);
        this.nav();
      }
      if (window.svDragScroll) window.svDragScroll(this.track, { snapSelector: '.sv-reels__item' });
      if (seenIo) seenIo.observe(this);
      if (autoIo) autoIo.observe(this);
      /* okno (ukryte) budujemy w wolnej chwili, żeby pierwsze dotknięcie nie płaciło za jego tworzenie */
      const idle = window.requestIdleCallback || ((f) => setTimeout(f, 200));
      idle(() => { if (!P) P = build(); }, { timeout: 4000 });
    }
    page(dir) {
      const item = this.track.querySelector('.sv-reels__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
      const per = Math.max(1, Math.floor((this.track.clientWidth - parseFloat(getComputedStyle(this.track).paddingLeft || 0)) / step));
      this.track.scrollBy({ left: dir * per * step, behavior: REDUCED.matches ? 'auto' : 'smooth' });
    }
    nav() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prevBtn.disabled = this.track.scrollLeft <= 4;
      this.nextBtn.disabled = max <= 4 || this.track.scrollLeft >= max - 4;
    }
  }

  /* ---------- okno z filmem ---------- */
  let P = null; // elementy okna (tworzone raz)
  let S = null; // stan bieżącego otwarcia

  function build() {
    const d = document.createElement('div');
    d.className = 'svr-player';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    d.setAttribute('aria-label', txt('dialog') || 'Filmy');
    d.setAttribute('tabindex', '-1');
    if (typeof d.showPopover === 'function') d.setAttribute('popover', 'manual');
    d.innerHTML =
      '<div class="svr-stage">' +
        '<div class="svr-frame">' +
          '<div class="svr-feed" tabindex="-1"></div>' +
          '<div class="svr-top">' +
            `<button type="button" class="svr-btn svr-mute" aria-pressed="false" aria-label="${esc(txt('mute'))}">${ICON.volOn}${ICON.volOff}</button>` +
            '<span class="svr-count" aria-live="polite"></span>' +
          '</div>' +
          `<div class="svr-hint" aria-hidden="true">${ICON.up}<span>${esc(txt('hint'))}</span></div>` +
          '<div class="svr-bottom">' +
            `<button type="button" class="svr-unmute">${ICON.mutedSmall}<span>${esc(txt('tap_unmute'))}</span></button>` +
            '<div class="svr-product" hidden><img alt="" width="44" height="44" decoding="async"><div class="svr-product__txt"><div class="svr-product__name"></div><div class="svr-product__price"></div></div><a class="svr-cta" href="#"></a></div>' +
            `<div class="svr-seek" role="slider" tabindex="0" aria-label="${esc(txt('seek'))}" aria-valuemin="0" aria-valuemax="0" aria-valuenow="0"><span class="svr-seek__track"><span class="svr-seek__fill"></span><span class="svr-seek__thumb"></span></span></div>` +
          '</div>' +
        '</div>' +
        `<button type="button" class="svr-btn svr-close" aria-label="${esc(txt('close'))}">${ICON.x}</button>` +
        '<div class="svr-nav">' +
          `<button type="button" class="svr-prev" aria-label="${esc(txt('prev'))}">${ICON.up}</button>` +
          `<button type="button" class="svr-next" aria-label="${esc(txt('next'))}">${ICON.down}</button>` +
        '</div>' +
      '</div>';
    document.body.appendChild(d);
    const q = (s) => d.querySelector(s);
    const v = document.createElement('video');
    v.playsInline = true; v.preload = 'auto'; v.controls = false;
    ['playsinline', 'webkit-playsinline', 'disablepictureinpicture'].forEach((a) => v.setAttribute(a, ''));
    const p = { d, v, stage: q('.svr-stage'), frame: q('.svr-frame'), feed: q('.svr-feed'), seek: q('.svr-seek'), seekFill: q('.svr-seek__fill'), seekThumb: q('.svr-seek__thumb'), count: q('.svr-count'),
      mute: q('.svr-mute'), close: q('.svr-close'), prev: q('.svr-prev'), next: q('.svr-next'), unmute: q('.svr-unmute'),
      product: q('.svr-product'), pImg: q('.svr-product img'), pName: q('.svr-product__name'), pPrice: q('.svr-product__price'), cta: q('.svr-cta') };

    let waitT = 0;
    v.addEventListener('playing', () => {
      clearTimeout(waitT);
      d.classList.remove('is-waiting', 'is-paused');
      if (!v.muted) d.classList.remove('is-autoplay-muted');
    });
    /* pasek przewijania z timeupdate (ok. 4 razy na sekundę) + płynne przejście CSS, bez pętli 60 klatek na sekundę */
    v.addEventListener('timeupdate', () => {
      if (!S || !isOpen() || !v.duration || S.seeking) return;
      seekDraw(v.currentTime / v.duration);
      /* czytnik ekranu ogłasza każdą zmianę wartości elementu z fokusem: przy fokusie na pasku bez odświeżania co sekundę */
      if (document.activeElement !== p.seek) seekAria();
    });
    p.seek.addEventListener('focus', () => seekAria());
    v.addEventListener('loadedmetadata', () => { if (S && isOpen()) seekAria(); });
    /* przewijanie filmu: przeciąganie po pasku (palec i mysz, touch-action: none), klik w miejsce paska, klawiatura na pasku */
    let wasPlaying = false;
    const seekAt = (e) => {
      const r = p.seek.getBoundingClientRect();
      const x = r.width ? Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) : 0;
      if (v.duration) {
        const t = Math.min(v.duration - 0.5, x * v.duration);
        if (S) S.seekT = t;
        /* w trakcie przeciągania szybkie skoki (Safari, Firefox: najbliższa klatka kluczowa), na końcu dokładne miejsce */
        if (typeof v.fastSeek === 'function' && S && S.seeking) v.fastSeek(t); else v.currentTime = t;
      }
      seekDraw(x);
    };
    p.seek.addEventListener('pointerdown', (e) => {
      if (!S || !v.duration || (e.pointerType === 'mouse' && e.button !== 0)) return;
      e.preventDefault();
      S.seeking = true;
      wasPlaying = !v.paused;
      d.classList.add('is-seeking');
      try { p.seek.setPointerCapture(e.pointerId); } catch (er) {}
      seekAt(e);
    });
    let seekRaf = 0, seekEv = null;
    p.seek.addEventListener('pointermove', (e) => {
      if (!S || !S.seeking) return;
      seekEv = e;
      if (!seekRaf) seekRaf = requestAnimationFrame(() => { seekRaf = 0; if (S && S.seeking && seekEv) seekAt(seekEv); });
    });
    const seekEnd = () => {
      if (!S || !S.seeking) return;
      S.seeking = false;
      d.classList.remove('is-seeking');
      if (typeof v.fastSeek === 'function' && typeof S.seekT === 'number') { try { v.currentTime = S.seekT; } catch (er) {} }
      seekAria();
      if (wasPlaying && v.paused && !v.ended) playNow();
    };
    p.seek.addEventListener('pointerup', (e) => { if (S && S.seeking) { if (seekRaf) { cancelAnimationFrame(seekRaf); seekRaf = 0; } seekAt(e); } seekEnd(); });
    p.seek.addEventListener('pointercancel', seekEnd);
    p.seek.addEventListener('lostpointercapture', seekEnd);
    p.seek.addEventListener('keydown', (e) => {
      if (!S || !v.duration) return;
      const k = e.key;
      let t = null;
      if (k === 'ArrowRight' || k === 'ArrowUp') t = v.currentTime + 5;
      else if (k === 'ArrowLeft' || k === 'ArrowDown') t = v.currentTime - 5;
      else if (k === 'PageUp') t = v.currentTime + v.duration / 10;
      else if (k === 'PageDown') t = v.currentTime - v.duration / 10;
      else if (k === 'Home') t = 0;
      else if (k === 'End') t = v.duration - 0.5;
      if (t === null) return;
      e.preventDefault();
      v.currentTime = Math.max(0, Math.min(v.duration - 0.5, t));
      seekDraw(v.currentTime / v.duration);
      seekAria();
    });
    v.addEventListener('pause', () => { if (!v.ended && S && !S.switching) d.classList.add('is-paused'); });
    v.addEventListener('waiting', () => { clearTimeout(waitT); waitT = setTimeout(() => d.classList.add('is-waiting'), 350); });
    v.addEventListener('canplay', () => { clearTimeout(waitT); d.classList.remove('is-waiting'); });
    v.addEventListener('ended', onEnded);
    v.addEventListener('error', () => {
      clearTimeout(waitT);
      d.classList.remove('is-waiting');
      /* 720p/480p są wyliczone z adresu 1080p; gdy pliku nie ma, wracamy do najwyższego MP4 z Liquid */
      const it = S && S.items[S.i];
      const cur = v.getAttribute('src') || '';
      if (it && it.m1080 && cur && cur !== it.m1080 && !it.fellBack) {
        it.fellBack = 1;
        track('sv_reel', { action: 'fallback', context: S.ctx, position: it.pos, video: (it.label || '').slice(0, 100), product: '' });
        v.setAttribute('src', it.m1080); playNow(); return;
      }
      d.classList.add('is-paused');
    });
    v.addEventListener('volumechange', () => syncMuted());

    p.close.addEventListener('click', () => closePlayer(false));
    d.addEventListener('click', (e) => { if (e.target === d || e.target === p.stage) closePlayer(false); });
    p.mute.addEventListener('click', () => setMuted(!v.muted, true));
    p.unmute.addEventListener('click', () => setMuted(false, true));
    p.prev.addEventListener('click', () => go(S ? S.i - 1 : 0));
    p.next.addEventListener('click', () => go(S ? S.i + 1 : 0));
    p.feed.addEventListener('click', (e) => {
      const tap = e.target.closest('.svr-tap');
      if (!tap || !S) return;
      if (d.classList.contains('is-autoplay-muted')) { setMuted(false, true); return; }
      if (v.paused || v.ended) { if (v.ended) v.currentTime = 0; playNow(); } else v.pause();
    });
    p.feed.addEventListener('scroll', () => { if (S && d.classList.contains('is-hint') && Math.abs(p.feed.scrollTop - S.startTop) > 30) d.classList.remove('is-hint'); }, { passive: true });
    /* klawiatura na całym dokumencie, gdy okno otwarte (fokus przenosimy dopiero po pierwszej klatce, okno nie wyłącza strony) */
    document.addEventListener('keydown', (e) => {
      if (!S || !isOpen()) return;
      const k = e.key;
      if (k === 'Tab') { trapTab(e); return; }
      if (e.target === P.seek && k !== 'Escape' && k !== 'Esc' && k !== ' ' && k !== 'm' && k !== 'M') return; /* obsługa na pasku */
      if (k === 'Escape' || k === 'Esc') { e.preventDefault(); closePlayer(false); return; }
      if (k === 'ArrowDown' || k === 'ArrowRight' || k === 'PageDown') { e.preventDefault(); go(S.i + 1); }
      else if (k === 'ArrowUp' || k === 'ArrowLeft' || k === 'PageUp') { e.preventDefault(); go(S.i - 1); }
      else if (k === ' ' && e.target === P.cta && P.cta.getAttribute('role') === 'button') { e.preventDefault(); P.cta.click(); }
      else if (k === ' ' && !(e.target.closest && e.target.closest('.svr-player button, .svr-player a'))) { e.preventDefault(); if (v.paused) playNow(); else v.pause(); }
      else if (k === 'm' || k === 'M') setMuted(!v.muted, true);
      else if (k === 'Home' || k === 'End') e.preventDefault();
    }, true);
    /* strona pod oknem się nie przewija: kółko myszy poza filmami i gest palcem na paskach sterowania (bez zmiany stylu <html>) */
    d.addEventListener('wheel', (e) => { if (!e.target.closest('.svr-feed')) e.preventDefault(); }, { passive: false });
    d.addEventListener('touchmove', (e) => { if (!e.target.closest('.svr-feed')) e.preventDefault(); }, { passive: false });
    p.cta.addEventListener('click', onCta);
    if ('ResizeObserver' in window) new ResizeObserver(() => { if (S && isOpen()) P.feed.scrollTop = S.i * P.feed.clientHeight; }).observe(p.feed);
    window.addEventListener('popstate', () => { if (S && isOpen()) closePlayer(true); });
    return p;
  }

  function isOpen() { return !!(P && P.d.hasAttribute('data-open')); }
  const fmt = (s) => { const n = Math.max(0, Math.floor(s || 0)); return Math.floor(n / 60) + ':' + String(n % 60).padStart(2, '0'); };
  function seekDraw(r) {
    const x = Math.max(0, Math.min(1, r || 0));
    P.seekFill.style.transform = `scaleX(${x})`;
    P.seekThumb.style.left = `${x * 100}%`;
  }
  function seekAria() {
    const v = P.v;
    const dur = v.duration && isFinite(v.duration) ? v.duration : 0;
    P.seek.setAttribute('aria-valuemax', String(Math.round(dur)));
    P.seek.setAttribute('aria-valuenow', String(Math.round(Math.min(dur, v.currentTime || 0))));
    P.seek.setAttribute('aria-valuetext', `${fmt(v.currentTime)} / ${fmt(dur)}`);
  }
  function trapTab(e) {
    const f = Array.prototype.filter.call(P.d.querySelectorAll('button, a[href], [tabindex="0"]'), (el) => !el.disabled && !el.hidden && el.tabIndex !== -1 && el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0]; const last = f[f.length - 1];
    if (!P.d.contains(document.activeElement) || document.activeElement === P.d) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function pageProduct(comp) {
    const d = comp.dataset;
    if (d.pdpUrl) return { url: d.pdpUrl, title: d.pdpTitle || '', price: d.pdpPrice || '', img: d.pdpImg || '', handle: d.pdpHandle || '', pdp: true };
    /* film bez produktu poza kartą produktu: przycisk „Zobacz produkty” (recenzja 11.10: inaczej okno na cały ekran bez wyjścia do sklepu) */
    return d.ctaUrl ? { url: d.ctaUrl, ctaOnly: true, handle: '' } : null;
  }

  function openPlayer(comp, index, opener) {
    if (!P) P = build();
    if (isOpen()) return;
    const items = comp.tiles.map(itemOf);
    S = { comp, items, i: -1, opener, ctx: comp.dataset.context || 'other', pageProduct: pageProduct(comp), switching: false, startTop: 0, done: {} };
    S.muted = store.get(KEY_MUTED) === '1';
    if (previewing) previewStop(previewing);
    S.paused = Array.prototype.filter.call(document.querySelectorAll('video'), (x) => !x.paused && x !== P.v);
    S.paused.forEach((x) => x.pause());
    P.feed.innerHTML = items.map((it, k) =>
      `<section class="svr-slide" data-k="${k}" aria-roledescription="${esc(txt('slide_role') || 'slajd')}" aria-label="${esc(txt('slide', { index: k + 1, total: items.length }))}">` +
        `<img class="svr-slide__poster" alt="" data-src="${esc(it.poster)}" decoding="async">` +
        `<button type="button" class="svr-tap" aria-label="${esc(txt('pause'))}"></button>` +
        `<span class="svr-bigplay" aria-hidden="true">${ICON.play}</span>` +
        '<span class="svr-spinner" aria-hidden="true"></span>' +
      '</section>').join('');
    P.d.dataset.svReelsContext = S.ctx;
    P.d.classList.remove('is-closing', 'is-paused', 'is-waiting', 'is-autoplay-muted', 'is-hint');
    P.d.classList.toggle('is-single', items.length < 2);
    if (!(window.history.state && window.history.state.svReels)) {
      try { window.history.pushState({ svReels: 1 }, ''); } catch (e) {}
    }
    P.d.setAttribute('data-open', '');
    if (P.d.hasAttribute('popover')) { try { P.d.showPopover(); } catch (e) {} }
    activate(index);
    /* fokus po pierwszej klatce okna (lab: focus() w obsłudze dotknięcia = ok. 25 ms przy CPU 4x) */
    /* po pierwszej klatce: fokus i klasa na <body>, po której popup zapisu (sv-goal-popup.js) czeka z otwarciem (przegląd 12.10, W2);
       nie w obsłudze dotknięcia, bo zmiana klasy <body> przelicza style strony */
    requestAnimationFrame(() => setTimeout(() => {
      if (!S || !isOpen()) return;
      document.body.classList.add('overflow-hidden-svreels');
      try { P.d.focus({ preventScroll: true }); } catch (e) {}
    }, 0));
    S.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting && e.intersectionRatio >= 0.6) activate(+e.target.dataset.k); });
    }, { root: P.feed, threshold: [0.6] });
    Array.prototype.forEach.call(P.feed.children, (s) => S.io.observe(s));
    if (!DESK.matches && !REDUCED.matches && items.length > 1 && !store.get(KEY_HINT)) {
      P.d.classList.add('is-hint');
      store.set(KEY_HINT, '1');
      setTimeout(() => P && P.d.classList.remove('is-hint'), 3300);
    }
    /* pozycja przewinięcia po wszystkich zmianach: jeden odczyt układu i tylko dla dalszych filmów (okno zamyka się
       z przewinięciem na górę); odczyt między zmianami = drugie przeliczenie układu (lab 12.10: 27-33 ms przy CPU 4x) */
    if (index > 0) P.feed.scrollTop = index * P.feed.clientHeight;
    S.startTop = index > 0 ? P.feed.scrollTop : 0;
    const it = items[index];
    const ev = { action: 'open', context: S.ctx, position: it.pos, video: (it.label || '').slice(0, 100), product: (it.product || S.pageProduct || {}).handle || '' };
    requestAnimationFrame(() => setTimeout(() => track('sv_reel', ev), 0));
  }

  function activate(k) {
    if (!S || k === S.i || k < 0 || k >= S.items.length) return;
    const slides = P.feed.children;
    const it = S.items[k];
    S.i = k;
    Array.prototype.forEach.call(slides, (s, j) => {
      s.classList.toggle('is-active', j === k);
      const tap = s.querySelector('.svr-tap');
      if (tap) tap.tabIndex = j === k ? 0 : -1; /* Tab tylko przez aktywny slajd */
    });
    for (let j = k - 1; j <= k + 1; j++) {
      const s = slides[j];
      if (!s) continue;
      const im = s.querySelector('.svr-slide__poster');
      if (!im.getAttribute('src') && im.dataset.src) im.setAttribute('src', im.dataset.src);
    }
    const v = P.v;
    S.switching = true;
    slides[k].insertBefore(v, slides[k].querySelector('.svr-tap'));
    S.switching = false;
    v.setAttribute('data-index', String(it.pos - 1));
    v.setAttribute('aria-label', it.label || txt('slide', { index: k + 1, total: S.items.length }));
    if (it.poster) v.setAttribute('poster', it.poster);
    const src = srcFor(it);
    if (v.getAttribute('src') !== src) v.setAttribute('src', src); else { try { v.currentTime = 0; } catch (e) {} }
    playNow();
    P.count.textContent = S.items.length > 1 ? `${k + 1} / ${S.items.length}` : '';
    S.seeking = false;
    P.d.classList.remove('is-seeking');
    seekDraw(0);
    seekAria();
    P.prev.disabled = k === 0;
    P.next.disabled = k === S.items.length - 1;
    setProduct(productFor(it));
  }
  /* film z produktem tej karty: „Dodaj do koszyka” (produkt strony), a nie link do tej samej karty */
  function productFor(it) {
    const pg = S.pageProduct;
    if (it.product && pg && pg.pdp && it.product.handle && it.product.handle === pg.handle) return pg;
    return it.product || pg;
  }

  function playNow() {
    const v = P.v;
    v.muted = S.muted;
    syncMuted();
    const pr = v.play();
    if (pr && pr.catch) {
      pr.catch((err) => {
        if (!S || (err && err.name === 'AbortError')) return;
        if (!v.muted) {
          v.muted = true;
          P.d.classList.add('is-autoplay-muted');
          syncMuted();
          v.play().catch(() => P.d.classList.add('is-paused'));
        } else {
          P.d.classList.add('is-paused');
        }
      });
    }
  }

  function setMuted(m, byUser) {
    if (!S) return;
    S.muted = m;
    P.v.muted = m;
    if (byUser) store.set(KEY_MUTED, m ? '1' : '0');
    if (byUser && !m) {
      const it = S.items[S.i] || {};
      track('sv_reel', { action: 'unmute', context: S.ctx, position: it.pos || 0, video: (it.label || '').slice(0, 100), product: (it.product || S.pageProduct || {}).handle || '' });
    }
    if (!m) P.d.classList.remove('is-autoplay-muted');
    if (!m && P.v.paused) playNow();
    syncMuted();
  }
  function syncMuted() {
    const m = P.v.muted;
    P.d.classList.toggle('is-muted', m);
    P.mute.setAttribute('aria-pressed', m ? 'true' : 'false');
    P.mute.setAttribute('aria-label', m ? txt('unmute') : txt('mute'));
  }

  function onEnded() {
    if (!S) return;
    const it = S.items[S.i];
    if (!S.done[S.i]) {
      S.done[S.i] = 1;
      track('sv_reel', { action: 'complete', context: S.ctx, position: it.pos, video: (it.label || '').slice(0, 100), product: (it.product || S.pageProduct || {}).handle || '' });
    }
    if (S.i < S.items.length - 1) go(S.i + 1);
    else P.d.classList.add('is-paused');
  }

  function go(k) {
    if (!S || k < 0 || k >= S.items.length) return;
    P.feed.scrollTo({ top: k * P.feed.clientHeight, behavior: REDUCED.matches ? 'auto' : 'smooth' });
    if (REDUCED.matches) activate(k);
  }

  function setProduct(pr) {
    if (!pr) { P.product.hidden = true; return; }
    P.product.hidden = false;
    P.product.classList.toggle('is-cta-only', !!pr.ctaOnly);
    if (pr.ctaOnly) {
      P.cta.textContent = txt('view_all');
      P.cta.setAttribute('href', pr.url);
      P.cta.removeAttribute('role');
      P.cta.dataset.mode = 'link';
      return;
    }
    P.pImg.src = pr.img || '';
    P.pImg.hidden = !pr.img;
    P.pName.textContent = pr.title;
    P.pPrice.textContent = pr.price;
    if (pr.pdp) {
      P.cta.textContent = txt('add_to_cart');
      P.cta.setAttribute('href', '#');
      P.cta.setAttribute('role', 'button');
      P.cta.dataset.mode = 'atc';
    } else {
      P.cta.textContent = txt('view');
      P.cta.setAttribute('href', pr.url);
      P.cta.removeAttribute('role');
      P.cta.dataset.mode = 'link';
    }
  }

  function onCta(e) {
    if (!S) return;
    const it = S.items[S.i];
    const pr = productFor(it);
    track('sv_reel', { action: 'cta', context: S.ctx, position: it.pos, video: (it.label || '').slice(0, 100), product: (pr || {}).handle || '' });
    if (P.cta.dataset.mode !== 'atc') return;
    e.preventDefault();
    closePlayer(false, () => {
      const btn = document.querySelector('product-info[id^="MainProduct-"] [id^="ProductSubmitButton-"]')
        || Array.prototype.find.call(document.querySelectorAll('[id^="ProductSubmitButton-"]'), (b) => !b.closest('.sticky-atc'));
      if (btn && !btn.disabled && !btn.hasAttribute('aria-disabled')) {
        const src = btn.form && btn.form.querySelector('input[name="properties[_sv_src]"]');
        const was = src ? src.value : null;
        if (src) src.value = 'pdp_film';
        btn.click();
        if (src) setTimeout(() => { src.value = was; }, 1500);
      } else {
        const info = document.querySelector('product-info, .product__info-container');
        if (info) info.scrollIntoView({ behavior: REDUCED.matches ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  function closePlayer(fromPop, after) {
    if (!S || !P || !isOpen() || S.closing) return;
    S.closing = true;
    const st = S;
    const done = () => {
      P.d.classList.remove('is-closing');
      if (st.io) st.io.disconnect();
      const v = P.v;
      v.pause();
      v.removeAttribute('src');
      v.removeAttribute('poster');
      try { v.load(); } catch (e) {}
      P.feed.scrollTop = 0; /* następne otwarcie pierwszego filmu bez odczytu układu */
      if (P.d.hasAttribute('popover')) { try { P.d.hidePopover(); } catch (e) {} }
      P.d.removeAttribute('data-open');
      document.body.classList.remove('overflow-hidden-svreels');
      P.feed.innerHTML = '';
      st.paused.forEach((x) => { if (x.muted && x.isConnected) { const pr = x.play(); if (pr && pr.catch) pr.catch(() => {}); } });
      if (st.opener && st.opener.focus) { try { st.opener.focus({ preventScroll: true }); } catch (e) {} }
      if (!fromPop && window.history.state && window.history.state.svReels) { try { window.history.back(); } catch (e) {} }
      S = null;
      if (after) setTimeout(after, 30);
    };
    /* „wstecz” w telefonie zamyka od razu (jak natywnie); X, Esc i klik w tło z krótką animacją */
    if (REDUCED.matches || fromPop) done();
    else { P.d.classList.add('is-closing'); setTimeout(done, 180); }
  }

  window.svReels = { open: openPlayer, close: () => closePlayer(false) };
  if (!window.customElements.get('sv-reels')) window.customElements.define('sv-reels', SvReels);
})();
